import { tWithKeyAttr as t } from "../../i18nHelper";
import React from 'react';
import styles from '../clinicalBackground/clinicalBackground.module.css';
import { getPrintDate, getTimeFromTimestamp, getUpdateReasonLabel, getUpdateReasonColor } from "../../utils/utils";
import dateIcon from "../../images/date_icon.svg";
import userIcon from "../../images/user_icon.svg";

const ClinicalBackgroundMetaData = ({ 
  version, 
  updateReason, 
  questionnaireId, 
  date, 
  userName,
}: { 
  version?: number; 
  updateReason?: string; 
  questionnaireId: number; 
  date?: string | null; 
  userName?: string | null; 
}) => {
  const renderUpdateReasonBadge = (updateReason: string | undefined, questionnaireId: number): JSX.Element | null => {
    if (!updateReason) return null;
    const badgeLabel = getUpdateReasonLabel(updateReason as string | null, questionnaireId);
    if (!badgeLabel) return null;
    
    return (
      <span className={`${styles.historyBadge} ${getUpdateReasonColor(updateReason as string | null, styles)}`}>
        {badgeLabel}
      </span>
    );
  };

  return (
    <div className={styles.historyVersionHeader}>
      <div className={styles.historyVersionInfo}>
        {version && (
          <span className={styles.historyVersionNumber}>
            {t("HISTORY_VERSION")} {version}
          </span>
        )}
         {userName && (
          <span className={styles.historyVersionNumber}>
            {userName}
          </span>
        )}
      
        {renderUpdateReasonBadge(updateReason, questionnaireId)}
      </div>
      <div className={styles.historyMetaInfo}>
        {date && (
          <div className={styles.historyMetaItem}>
            <img src={dateIcon} alt={t('DATE')} className={styles.historyMetaIcon} />
            <span className={styles.historyMetaText}>
              {getPrintDate(new Date(date), true)} {getTimeFromTimestamp(date)}
            </span>
          </div>
        )}
       
      </div>
    </div>
  );
};

export default ClinicalBackgroundMetaData;

